import React from 'react';
import logo from '../../assets/images/logo2x.png';
import rightLowerBG from '../../assets/images/RightImg.png';
import './style.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="authLayoutRoot">
      {/* Left column - background image and footer (hidden on small screens) */}
      <div className="authLayoutLeft">
        <div className="leftBG">
          <div className="overlay">
            <img src={logo} alt="IQVIA Logo" className="logo" />
            <div className="shapes">
              <div className="bigRectangle">
                <div className="textContainer">
                  <h1 className="title">Conveyor</h1>
                  <p className="description">
                    Conveyor is a core engine featuring a modular architecture
                    that empowers dynamic configuration for building diverse
                    platforms. It encompasses comprehensive user management,
                    granting administrators granular control over user roles and
                    permissions.
                  </p>
                </div>
              </div>
              <div className="smallRectangle"></div>
            </div>
          </div>
          <div className="footer">
            <img src={logo} alt="IQVIA Logo" className="footerLogo" />
            <ul className="footerLinks">
              <li>
                <a
                  href="https://www.iqvia.com/about-us/terms-of-use"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="https://www.iqvia.com/about-us/privacy/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="mailto:eService@iqvia.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Right column - Sign In form and right footer */}
      <div className="authLayoutRight">
        <div className="rightBG">
          <div className="rightBGContent">{children}</div>
          <img
            src={rightLowerBG}
            alt="Decorative"
            className="bottomRightImage"
          />
          <div className="rightFooter">
            Copyright © 2024 IQVIA. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
